<script>
  import Chart from "svelte-chartjs/src/Bar.svelte";
  import {defaultErrorHandling, formatSecondsTimeStamp, getVideoService} from "../static";
  import {onMount} from "svelte";
  export let videoId = 0;
  export let isLoading = false;
  import {M} from "../../external.js";

  const graphChartOptions = {
    responsive: true,
    plugins: {
      legend: false,
      title: false,
      tooltip: {
        mode: "index",
        intersect: false,
        displayColors: false
      }
    },
    scales: {
      xAxes: {
        display: true,
        title: {
          display: true,
          text: M.VIDEO_DURATION
        },
        grid: { display: false },
        ticks: {
          autoSkip: true,
          maxTicksLimit: 3,
          maxRotation: 0
        }
      },
      yAxisGraphBar: {
        type: "linear",
        position: "right",
        display: true,
        grid: { display: false },
        ticks: {
          autoSkip: true,
          maxTicksLimit: 4,
          maxRotation: 0
        }
      }
    },
    layout: {
      autoPadding: true
    }
  };
  const engagementColor = '#FF55B8';
  const engagementGradientColors = ["transparent", "#FF8787"];
  //video duration based on time unit
  let videoDuration = 0;
  //time step for each data point
  let timeStep = 1;
  export let engagementData = [];
  export let graphData = {};

  let totalViews = 0;
  let totalEngagement = 0;
  let avgViewDuration = 0;

  onMount(() => {
    if (!engagementData || engagementData.length === 0) {
      setEngagementChart();
    }
  });

  let setEngagementChart = () => {
    isLoading = true;
    getVideoService('/analytics/graph/' + videoId)
        .then(resp => {
          setEngagementTab(resp.analytic, resp.durationInSec);
          videoDuration = resp.durationInSec;
          timeStep = videoDuration / 100;
          let {labels, data, engagement} = processEngagementData(resp.data);
          engagementData = engagement;
          graphData = {
            labels: labels,
            datasets: [
              {
                label: '',
                data: data,
                backgroundColor: engagementGradientColors,
                fill: true,
                lineTension: 0.3,
                borderColor: "#FF8787",
                pointRadius: 0,
                pointHoverRadius: 0,
                tension: 0.1,
                borderRadius: 30,
                order: 1,
                type: "line",
                yAxisID: "yAxisGraphBar",
				        xAxisID: "xAxes"
              }
            ]
          }
          isLoading = false;
        })
        .catch(err => {
          isLoading = false;
          defaultErrorHandling();
        })
  }

  let setEngagementTab = (analytic, durationInSec) => {

    totalViews = analytic.totalViews;
    if (analytic.totalViews > 0) {
      totalEngagement = (analytic.totalPlayTime / (analytic.totalViews * Math.floor(durationInSec)) * 100).toFixed(2);
    }
    if (analytic.totalViews > 0) {
      avgViewDuration = (analytic.totalPlayTime / analytic.totalViews).toFixed(2);
    }
  }

  const processEngagementData = (resp) => {
    if (!resp || resp.length === 0) {
      return {
        labels: new Array(100).fill(''),
        data: new Array(100).fill(0),
        engagement: new Array(100).fill({})
      };
    }
    let engagement = [];
    let pivot = resp[0] | 0;
    let engagementPerc = pivot;
    let labels = [('0')];
    let startingPercent = pivot > 0 ? 100 : 0;
    let data = [];
    data.push(startingPercent);
    engagement.push({label: 0, data: startingPercent, time: 0});
    for (let i = 1; i < 100; i++) {
      let value = resp[i] | 0;
      pivot += value;
      if (pivot < 0) {
        pivot = 0;
      }
      let label = (i * timeStep);
      labels.push(formatSecondsTimeStamp(label));
      let d = 0;
      if (pivot > 0) {
        d = ((pivot / engagementPerc) * 100).toFixed(2);
      }
      data.push(d);
      engagement.push({
        label: formatSecondsTimeStamp(label),
        data: d,
        time: (i * timeStep).toFixed(2)
      });
    }
    return {
      labels: labels,
      data: data,
      engagement: engagement
    };
  }


</script>

<div class="padded-crm-wrapper-outer video-analytics-wrapper">

  <div class="flex col20 f-left padded-section-analytics-warapper white-bg mb-15">
    <div class="analytics-box with-right-border">
      <h3 class="flex align-center">{M.TOTAL_VIEWS}</h3>
      <h2 class="col20 f-left f-28 gray-text"><b id="videoTotalViews">{totalViews}</b> </h2>
    </div>
    <div class="analytics-box with-right-border">
      <h3 class="flex align-center">{M.ENGAGEMENT}
        <span class="material-icons-outlined ml-5 stats-info" style="font-size: 20px;">
          info
          <span class="none-soft hidden-info">
            <h4>{M.ENGAGEMENT}</h4>
            <span>{M.ENGAGEMENT_DESC}</span>
          </span>
        </span>
      </h3>
      <h2 class="col20 f-left f-28 gray-text"><b id="videoEngagement">{totalEngagement}%</b></h2>
    </div>
    <div class="analytics-box">
      <h3 class="flex align-center">{M.AVERAGE_VIEW_DURATION}</h3>
      <h2 class="col20 f-left f-28 gray-text">
        <b id="videoViewDuration">{formatSecondsTimeStamp(avgViewDuration)}</b>
      </h2>
    </div>
  </div>
  <div class="col20 f-left relative mt-15 modern-chart-box modern-chart-box-compact">
    <div id="videoChartGraph">
      <Chart data={graphData} options={graphChartOptions} />
    </div>

  <div class="axis">
  {#each engagementData as g}
   <div class="tick">
      <span class="value value-first">
           <b style="font-size:18px; color: #e67878;">{g.data}%</b>
       </span>
       <span class="value value-second">
           {g.label}
       </span>
    </div>
      {/each}
    </div>
  </div>
</div>
